import {
  AfterContentChecked,
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { FieldsAccessService } from 'src/app/core/services/fields-access/fields-access.service';

@Component({
  selector: 'app-select-field',
  templateUrl: './select-field.component.html',
  styleUrls: ['./select-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SelectFieldComponent
  implements AfterViewInit, OnChanges, AfterContentChecked, OnDestroy
{
  @Input() autocomplete: boolean;
  @Input() invalid: boolean;
  @Input() label: string;
  @Input() labelFor: string;
  @Input() uppercase = false;
  @Input() disabled = false;
  @Input() readonly = false;
  @Input() clearedStyle = false;
  @Input() small = false;

  @ViewChild('field') field: ElementRef;

  lastSelectClassList: string;
  selectedOption: number;
  inputField: string;
  selectField: string;
  attr: { id: string; name: string; autocomplete: string; class: string };
  disabledStateStr: string;
  canEdit: boolean;
  $globalAccess = new Subscription();

  constructor(private fieldsAccessService: FieldsAccessService) {
    this.inputField = 'input';
    this.selectField = 'ng-select';
    this.attr = {
      id: 'id',
      name: 'name',
      autocomplete: 'autocomplete',
      class: 'select-field-element',
    };
    this.disabledStateStr = 'disabled';
  }

  ngAfterViewInit(): void {
    this.setFieldAttr();
    this.toggleDisabledAttr();
    this.preserveGlobalAccess();
  }

  ngOnChanges(): void {
    this.setFieldAttr();
    this.toggleDisabledAttr();
  }

  ngAfterContentChecked(): void {
    const select = this.getSelect();
    if (select && select.classList !== this.lastSelectClassList) {
      this.lastSelectClassList = select.classList.value;
      this.updateInvalidState();
      this.updateDisabledState();
    }
  }

  ngOnDestroy(): void {
    this.$globalAccess.unsubscribe();
  }

  preserveGlobalAccess(): void {
    this.$globalAccess = this.fieldsAccessService.canEdit.subscribe((canEdit) => {
      this.canEdit = canEdit;
      this.disabled = canEdit ? this.disabled : true;
    });
  }

  getField(): any {
    return this.field?.nativeElement.querySelector(this.inputField);
  }

  getSelect(): any {
    return this.field?.nativeElement.querySelector(this.selectField);
  }

  getLabel(): string {
    return this.uppercase ? this.label.toUpperCase() : this.label;
  }

  setFieldAttr(): void {
    const field = this.getField();
    if (field) {
      field.classList.add(this.attr.class);
      field.setAttribute(this.attr.autocomplete, 'off');
      if (this.labelFor) {
        field.setAttribute(this.attr.id, this.labelFor);
        field.setAttribute(this.attr.name, this.labelFor);
      }
    }
  }

  updateInvalidState(): void {
    const invalid =
      this.lastSelectClassList.includes('ng-invalid') &&
      this.lastSelectClassList.includes('ng-touched');
    this.invalid = invalid;
  }

  updateDisabledState(): void {
    if (!this.canEdit) {
      return;
    }
    const disabled = this.lastSelectClassList.includes('disabled');
    this.disabled = disabled;
  }

  toggleDisabledAttr(): void {
    const field = this.getField();
    if (!field || !this.canEdit) {
      return;
    }

    if (this.disabled) {
      field.disabled = true;
      return;
    }

    field.removeAttribute(this.disabledStateStr);
  }
}
